<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  import { EventBus } from "@/event-bus";
  //import { VueDaumPostcode } from "vue-daum-postcode/dist";
  import VueEasyLightbox from "vue-easy-lightbox";
  import html2canvas from "html2canvas";
  
  // 초기세팅
  function initialState (){
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      basicInfo: [],
      thisIdx: 0, // 현재 회원 번호
      memberData: {}, // 회원 상세 정보
      memberLogList: [], // 회원 상세 로그 리스트
      visibleSignatureImage: false, // 서명 이미지 라이트박스 표시 여부
      currentIndexSignatureImage: 0, // 서명 이미지 라이트박스 표시 인덱스
      lightboxSignatureImageImgs: [], // 서명 이미지 라이트박스 이미지 리스트
      showMemberLogListOn: false, // 로그 리스트 보이기 여부
      showConvertToJpgModal: false, // 후원신청서 JPG 변환 미리보기 모달
      policy: {
        policy1: "",
        policy2: "",
      },
      returnSignatureImageForCapture: '',
    };
  }
  export default {
    components: {
      //VueDaumPostcode,
      VueEasyLightbox,
    },
    data() {
      return initialState();
    },
    watch: {
    },
    created() {
      // 초기실행
      this.first();
    },
    computed: {
    },
    mounted() {  
    },
    methods: {
      // 천단위 콤마 추가 
      number_format(value) {
        return value.toLocaleString();
      },
      // 초기화
      resetWindow: function (){
        Object.assign(this.$data, initialState());
      },
      // 처음실행
      first: function() {
        this.resetWindow();
        // 사용자 정보 가져오자
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
        }
        // store에서 정보받기
        this.basicInfo = this.$store.getters.getModal_lg
        if (this.basicInfo.worker=="detailGiveMember") {
          this.thisIdx = this.basicInfo.val.idx
          this.selectGiveMember()
        }
      },
      // 닫기
      hide() {
        this.$store.commit('setModal_lgVal', ''); // store.js 로 닫히니까 정리해주자
        this.$store.commit('setModal_lgWorker', ''); // store.js 로 닫히니까 정리해주자
        this.$bvModal.hide('modal_lg');
        // 닫을 때 관리 계정쪽에 리플레쉬 하자
        EventBus.$emit("give-member", "listRefresh");
      },
      selectGiveMember() {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_read_give_member_detail',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_id": this.login.idx,
              "idx": this.thisIdx,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              if (res.data.giveMemberInfo) {
                this.memberData = res.data.giveMemberInfo;
              }
              if (res.data.giveMemberLog) {
                this.memberLogList = res.data.giveMemberLog;
              }
              if (res.data.policy) {
                this.policy.policy1 = res.data.policy.policy1 || '';
                this.policy.policy2 = res.data.policy.policy2 || '';
              }
              // 서명 이미지 가져오자
              this.getSignatureImageForCapture();
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': res.data.type+' 에러', text: res.data.detail })
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
        } catch (error) {
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      // 수정 저장
      updateGiveMember() {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_update_give_member_detail',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_idx": this.login.idx,
              "idx": this.thisIdx,
              "memberData": this.memberData,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '저장되었습니다.' })
              // 현재창 조회 리플레쉬
              this.selectGiveMember();
              // 부모창 리플레쉬 이벤트 발생
              EventBus.$emit("give-member", "listRefresh");
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': res.data.type+' 에러', text: res.data.detail })
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
        } catch (error) {
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      formatSSN(event) {
        let value = event.target.value.replace(/[^0-9]/g, ''); // 숫자만 추출
        // 13자리 제한 (000000-0000000)
        if (value.length > 13) {
          value = value.substring(0, 13);
        }
        // 하이픈 추가
        if (value.length > 6) {
          value = value.substring(0, 6) + '-' + value.substring(6);
        }
        this.memberData.ssn = value;
        event.target.value = value;
      },
      // 기다려주세요 loading 처리
      loadingBar(val) {
        if (val === true) {
          document.getElementById("preloader").style.display = "block";
          document.getElementById("status").style.display = "block";
        } else {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }
      },
      /*
      // 주소 찾기
      openAddressWindow() {
        this.$bvModal.show('modal_lg_address')
      },
      // 주소 검색 결과 반환
      addressComplete:function(result) {
        if(result.userSelectedType === 'R'){  // 도로명 주소 선택
          this.memberData.address = result.roadAddress;
        } else {  // 지번 주소 선택
          this.memberData.address = result.jibunAddress;
        }
        this.$bvModal.hide('modal_lg_address')
      },
      */
      returnSignatureImage(signatureImage) {
        return appConfig.fileserver + '/support_apply/' + signatureImage;
      },
      openSignatureWindow() {
        this.lightboxSignatureImageImgs = [this.returnSignatureImage(this.memberData.signatureImage)];
        this.currentIndexSignatureImage = 0;
        this.visibleSignatureImage = true;
      },
      showMemberLogList() {
        this.showMemberLogListOn = !this.showMemberLogListOn;
      },
      deleteGiveMember() {
        if (confirm('회원을 정말 영구히 삭제하시겠습니까?')) {
          try {
            this.loadingBar(true)
            axios({
              method: 'POST',
              url: appConfig.fastapi + '/auth/admin_delete_give_member',
              headers: {
                'access-token': this.token
              },
              data: {
                "idx": this.thisIdx
              },
            })
            .then((res) => {
              if (res.data.type == 'success') {
                this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '삭제되었습니다.' })
                this.hide();
              } else {
                this.$notify({ type: 'error', duration: 3000, 'title': res.data.type+' 에러', text: res.data.detail })
              }
            })
            .catch((error) => {
              console.log(error)
              if (error.response) {
                this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
              }
            })
          } catch (error) {
            console.log(error)
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          } finally {
            this.loadingBar(false)
          }
        } else {
          return false;
        }
      },
      somethingDelete() {
        if (confirm('CMS프로그램에 입력 후 지우는 작업이 맞으신가요?')) {
          try {
            this.loadingBar(true)
            axios({
              method: 'POST',
              url: appConfig.fastapi + '/auth/admin_clear_give_member_info',
              headers: {
                'access-token': this.token
              },
              data: {
                "mb_idx": this.login.idx,
                "idx": this.thisIdx
              },
            })
            .then((res) => {
              if (res.data.type == 'success') {
                this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '삭제되었습니다.' })
                this.selectGiveMember();
              } else {
                this.$notify({ type: 'error', duration: 3000, 'title': res.data.type+' 에러', text: res.data.detail })
              }
            })
            .catch((error) => {
              console.log(error)
              if (error.response) {
                this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
              }
            })
          } catch (error) {
            console.log(error)
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          } finally {
            this.loadingBar(false)
          }
        }
      },
      sendSms(phone) {
        alert('아직 미구현 기능입니다.');
      },
      sendEmail(email) {
        alert('아직 미구현 기능입니다.');
      },
      // 2026-01-29 01:44:14 이렇게 된걸 2026년 01월 29일로 변경
      convertDate(date) {
        if (date) {
          const year = date.substring(0, 4);
          const month = date.substring(5, 7);
          const day = date.substring(8, 10);
          return year + '년 ' + month + '월 ' + day + '일';
        } else {
          return '-';
        }
      },
      convertToJpg() {
        this.showConvertToJpgModal = true;
      },
      closeConvertToJpgModal() {
        this.showConvertToJpgModal = false;
      },
      convertBirthday(birthday, ssn) {
        // 생년월일 넣었으면 생년월일 1984-02-17 형식으로 그대로 나오면 되고 아니면 주민번호 앞자리 6개 추출해서 1984-02-17 형식으로 바꿔주자  
        if (birthday) {
          return birthday;
        } else if (ssn) {
          // 840217 형식을 1984-02-17 형식으로 바꿔주자 (뒷자리 첫번째가 1또는 2라면 앞에 19붙이고 그 외는 20붙이자)
          const year = ssn.substring(0, 2);
          const month = ssn.substring(2, 4);
          const day = ssn.substring(4, 6);
          const gender = ssn.substring(ssn.indexOf('-') + 1, ssn.indexOf('-') + 2); // 840217-1630511에서 - 뒤에 첫번째꺼
          // 뒷자리 첫번째가 1또는 2라면 앞에 19붙이고 그 외는 20붙이자
          if (gender == '1' || gender == '2') {
            return '19' + year + '-' + month + '-' + day;
          } else {
            return '20' + year + '-' + month + '-' + day;
          }
        }
        return '-';
      },
      // 백엔드에서 data url로 변환된 서명 가져오자
      getSignatureImageForCapture() {
        // 서명있을 경우에만
        if (this.memberData.signatureImage != '' && this.memberData.signatureImage != null) {
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_read_signature_image',
            headers: {
              'access-token': this.token
            },
            data: {
              "idx": this.thisIdx
            }
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.returnSignatureImageForCapture = 'data:' + res.data.contentType + ';base64,' + res.data.signatureImage;
            } else {
              this.returnSignatureImageForCapture = '';
              this.$notify({ type: 'error', duration: 3000, title: '오류', text: res.data.detail });
            }
          })
          .catch((error) => {
            console.error(error);
            this.returnSignatureImageForCapture = '';
          });
        } else {
          this.returnSignatureImageForCapture = '';
        }
      },
      // img.himne.org 등 외부 이미지를 프록시로 가져와 data URL로 변환 (CORS 회피)
      async imageUrlToDataUrl(imageUrl) {
        const proxyUrl = appConfig.fastapi + '/auth/proxy_image?url=' + encodeURIComponent(imageUrl);
        const res = await fetch(proxyUrl, { credentials: 'omit' });
        if (!res.ok) throw new Error('이미지 로드 실패');
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      },
      // 캡쳐 실행
      async captureSupportApplyToJpg() {
        const el = document.getElementById('support-apply-preview');
        if (!el) {
          this.$notify({ type: 'error', duration: 3000, title: '오류', text: '캡처할 영역을 찾을 수 없습니다.' });
          return;
        }
        const imgs = el.querySelectorAll('img[src*="img.himne.org"]');
        const restores = [];
        try {
          for (const img of imgs) {
            const origSrc = img.getAttribute('src');
            if (!origSrc) continue;
            try {
              const dataUrl = await this.imageUrlToDataUrl(origSrc);
              img.setAttribute('src', dataUrl);
              restores.push(() => img.setAttribute('src', origSrc));
            } catch (_) {
              const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
              img.setAttribute('src', placeholder);
              restores.push(() => img.setAttribute('src', origSrc));
            }
          }
          const canvas = await html2canvas(el, {
            useCORS: false,
            allowTaint: false,
            backgroundColor: '#ffffff',
            scale: 2,
            logging: false,
          });
          const dataUrl = canvas.toDataURL('image/jpeg', 0.95);
          const link = document.createElement('a');
          const fileName = '후원신청서_' + (this.memberData.name || '회원') + '_' + new Date().getTime() + '.jpg';
          link.download = fileName;
          link.href = dataUrl;
          link.click();
          this.$notify({ type: 'success', duration: 3000, title: '완료', text: 'JPG 파일이 다운로드되었습니다.' });
        } catch (err) {
          console.error(err);
          this.$notify({ type: 'error', duration: 3000, title: '캡처 실패', text: err.message || '캡처 중 오류가 발생했습니다.' });
        } finally {
          restores.forEach((r) => r());
        }
      },
      checkMemberData() {
        // 주소, 계좌번호, 월후원금액, 자동이체 출금일, 주민등록번호, 생년월일 모두 비어있으면 false 아니면 true 반환
        if (
          (this.memberData.address == '' || this.memberData.address == null) && 
          (this.memberData.address2 == '' || this.memberData.address2 == null) && 
          (this.memberData.bank == '' || this.memberData.bank == null) && 
          (this.memberData.accountNumber == '' || this.memberData.accountNumber == null) && 
          (this.memberData.customAmount == '' || this.memberData.customAmount == null) && 
          (this.memberData.selectDay == '' || this.memberData.selectDay == null) && 
          (this.memberData.birthday == '' || this.memberData.birthday == null) && 
          (this.memberData.ssn == '' || this.memberData.ssn == null)
        ) {
          return false;
        } else {
          return true;
        }
      },
    }, // methods 종료
    middleware: "authentication",
  };
  </script>
  
  <template>
    
    <div v-if="basicInfo.worker=='detailGiveMember'" class="row">

      <!-- 이미지 크게 -->
      <vue-easy-lightbox :visible="visibleSignatureImage" :index="currentIndexSignatureImage" :imgs="lightboxSignatureImageImgs" scrollDisabled='false' @hide="visibleSignatureImage = false"></vue-easy-lightbox>

      <!-- 후원신청서 JPG 변환 미리보기 모달 -->
      <b-modal
        v-model="showConvertToJpgModal"
        id="modal_convert_to_jpg"
        size="lg"
        centered
        title="후원신청서"
        title-class="font-size-18 font-weight-bold"
        hide-footer
        @hidden="closeConvertToJpgModal"
      >
        <div class="mb-3 ">
          <button class="btn btn-sm btn-block btn-square btn-blue" @click="captureSupportApplyToJpg">
            <i class="mdi mdi-image"></i> JPG로 저장
          </button>
        </div>
        <div id="support-apply-preview" class="support-apply-preview p-3 bg-white border">
          <!-- 헤더: 후원신청서 -->
          <div class="text-center border-bottom pb-3 mb-3">
            <h6 class="font-weight-bold mb-0">대구여성인권센터 후원신청서</h6>
          </div>
          <!-- 본문 필드 (읽기 전용) -->
          <div class="row font-size-12">
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">이름</span>
              <span>{{ memberData.name || '-' }}</span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">휴대전화번호</span>
              <span>{{ memberData.phone || '-' }}</span>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">주소</span>
              <span>{{ memberData.address || '-' }} {{ memberData.address2 || '' }}</span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">회원유형</span>
              <span class="d-flex align-items-center font-size-12">
                <span :class="memberData.memberType === '정회원' ? 'text-primary font-weight-bold' : ''">{{ memberData.memberType === '정회원' ? '☑' : '□' }} 정회원</span>
                <span class="mx-2">/</span>
                <span :class="memberData.memberType === '후원회원' ? 'text-primary font-weight-bold' : ''">{{ memberData.memberType === '후원회원' ? '☑' : '□' }} 후원회원</span>
              </span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">납입방식</span>
              <span class="d-flex align-items-center font-size-12">
                <span :class="memberData.selectDay !=''&& memberData.selectDay != null ? 'text-primary font-weight-bold' : ''">{{ memberData.selectDay !=''&& memberData.selectDay != null ? '☑' : '□' }} CMS</span>
                <span class="mx-2">/</span>
                <span :class="memberData.selectDay ==''|| memberData.selectDay == null ? 'text-primary font-weight-bold' : ''">{{ memberData.selectDay ==''|| memberData.selectDay == null ? '☑' : '□' }} 계좌이체</span>
              </span>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">기부금영수증(홈택스)</span>
              <span class="d-flex align-items-center font-size-12">
                <span :class="memberData.receiptAgree === '발급함' ? 'text-primary font-weight-bold' : ''">{{ memberData.receiptAgree === '발급함' ? '☑' : '□' }} 발행</span>
                <span class="mx-2">/</span>
                <span :class="memberData.receiptAgree === '발급안함' ? 'text-primary font-weight-bold' : ''">{{ memberData.receiptAgree === '발급안함' ? '☑' : '□' }} 발행안함</span>
              </span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">금융기관명</span>
              <span>{{ memberData.bank || '-' }}</span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">출금계좌번호</span>
              <span>{{ memberData.accountNumber || '-' }}</span>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">출금액</span>
              <span>{{ memberData.customAmount ? number_format(memberData.customAmount) + '원' : '-' }}</span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">출금일</span>
              <span>{{ memberData.selectDay ? '매월 ' + memberData.selectDay + '일' : '-' }}</span>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">생년월일</span>
              <span>{{ convertBirthday(memberData.birthday, memberData.ssn) }}</span>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-6 mb-2">
              <span class="text-muted d-block">주민등록번호</span>
              <span>{{ memberData.ssn || '-' }}</span>
            </div>
          </div>
          <!-- 하단: 개인정보 수집 및 이용 동의, 개인정보 제3자 제공에 대해 동의 -->
          <div class="border-top pt-3 mt-3 font-size-11 text-dark">
            <!-- 개인정보 수집 및 이용 동의 -->
            <div class="border p-1">
              <div v-html="policy.policy1" class="font-size-11"></div>
            </div>
            <div class="mb-2">☑ 개인정보 수집 및 이용 동의</div>
            <div class="border p-1">
              <div v-html="policy.policy2" class="font-size-11"></div>
            </div>
            <div class="mb-3">☑ 개인정보 제3자 제공에 대해 동의</div>
            <div class="border p-1 mb-2">
              <div class="font-size-11">[출금이체동의여부 및 해지사실통지 안내]</div>
              <div class="font-size-11">
                CMS 이용약관에 따라 은행 등 금융회사 및 금융결제원은 CMS 제도의 안정적 운영을 위하여 고객의 연락처 정보(은행 등 금융회사 및 이용기관보유)를 활용하여</br>
                문자메세지, 유선 등으로 고객의 출금이체 동의여부 및 해지 사실을 통지할 수 있습니다</br></br>
                상기금융거래정보의 제공 및 개인정보 수집 및 이용, 개인정보 제3자 제공에 동의하며 CMS 출금이체를 신청합니다.
              </div>
            </div>
            <!-- 오늘 날짜 -->
            <div class="text-center font-size-13 mb-1">
              {{ convertDate(memberData.insertTime) }}
            </div>
            <!-- 신청인 이름 + 서명 -->
            <div class="text-center font-size-14">
              <span class="mr-4">신청인 
                <b class="font-size-14 ml-2">{{ memberData.name || '' }}</b>
              </span>
              <span class="mr-1">서명:</span>
              <div v-if="memberData.signatureImage" class="d-inline-block " style="max-height: 100px;">
                <img :src="this.returnSignatureImageForCapture" alt="서명" class="img-fluid" style="max-height: 70px; width: auto;" />
              </div>
              
              <span v-else class="text-muted font-size-10">(서명 없음)</span>
            </div>
          </div>
        </div>
        <div class="mt-3 ">
          <button class="btn btn-sm btn-block btn-square btn-blue" @click="captureSupportApplyToJpg">
            <i class="mdi mdi-image"></i> JPG로 저장
          </button>
        </div>
      </b-modal>

      <!-- 주소 검색 모달 (사용안함)
      <b-modal
        id="modal_lg_address"
        centered
        title="배송지 주소 찾기"
        title-class="font-size-18"
        hide-footer
      >
        <VueDaumPostcode @complete="addressComplete"></VueDaumPostcode>
      </b-modal>
      -->

      <div class="col-xl-12">
        <div class="border-bottom p-1 mb-2">
          <div class="p-0">
            <div class="media align-items-center">
              <div class="media-body overflow-hidden">
                <div class="h4">
                  <span class="text-dark">
                    <i class="mdi mdi-smart-card-outline text-blue"></i>
                    회원 정보 수정
                  </span>
                </div>
              </div>
              <a class="" href="javascript:void(0);" @click="hide">
                <div class="btn btn-block p-0">
                  <i class="mdi mdi-close display-6 text-secondary"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      
      <!-- 저장 -->
      <div class="col-xl-12 mt-2 mb-2">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 mb-2">
            <button @click="updateGiveMember()" class="btn btn-sm btn-square btn-block btn-primary font-weight-bold font-size-12">
              <i class="mdi mdi-content-save"></i>
              저장하기
            </button>
          </div>
        </div>
      </div>
  
      <!-- 본문 -->
      <div v-if="memberData !== null && memberData !== undefined" class="col-xl-12 mt-2 mb-2">
        <div class="col-lg-12">
          <div class="row">
            <!-- 본문폼 -->
            <div class="col-xl-12 col-md-12 col-sm-12 p-2 border " 
            :class="{'bg-soft-warning': memberData.status == '승인요청', 'bg-soft-danger': memberData.status == '승인보류', 'bg-light': memberData.status == '승인완료'}">
              <div class="row">
                <div class="col-xl-3 col-md-6 col-sm-6">
                  <div class="">
                    <label for="modalMemberDataStatus" class="font-size-12 mb-0">상태 <span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <div style="flex: 1; width: 100%;">
                        <select
                          ref="modalMemberDataStatus"
                          name="modalMemberDataStatus"
                          id="modalMemberDataStatus"
                          v-model="memberData.status"
                          type="select"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="승인요청">승인요청</option>
                          <option value="승인보류">승인보류</option>
                          <option value="승인완료">승인완료</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6">
                  <div class="">
                    <label for="modalMemberDataType" class="font-size-12 mb-0">회원유형 <span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <div style="flex: 1; width: 100%;">
                          <select
                            ref="modalMemberDataType"
                            name="modalMemberDataType"
                            id="modalMemberDataType"
                            v-model="memberData.memberType"
                            type="select"
                            class="form-control form-control-sm"
                            required
                          >
                            <option value="정회원">정회원</option>
                            <option value="후원회원">후원회원</option>
                            <option value="비회원">비회원</option>
                            <option value="회원유형없음">회원유형없음</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6">
                  <div class="">
                    <label for="modalMemberRegisterType" class="font-size-12 mb-0">등록구분 <span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <div style="flex: 1; width: 100%;">
                          <select
                            ref="modalMemberRegisterType"
                            name="modalMemberRegisterType"
                            id="modalMemberRegisterType"
                            v-model="memberData.registerType"
                            type="select"
                            class="form-control form-control-sm"
                            required
                          >
                            <option value="개인">개인</option>
                            <option value="기업/단체">기업/단체</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6">
                  <div class="">
                    <label for="modalMemberIsPress" class="font-size-12 mb-0">언론기자 유무 <span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <div style="flex: 1; width: 100%;">
                          <select
                            ref="modalMemberIsPress"
                            name="modalMemberIsPress"
                            id="modalMemberIsPress"
                            v-model="memberData.isPress"
                            type="select"
                            class="form-control form-control-sm"
                            required
                          >
                            <option value="0">일반인</option>
                            <option value="1">언론보도_기자</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataName" class="font-size-12 mb-0">성명 <span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.name" class="form-control form-control-sm pl-3" name="modalMemberDataName" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataPhone" class="font-size-12 mb-0">휴대폰번호 <span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.phone" class="form-control form-control-sm pl-3" name="modalMemberDataPhone"/>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataSmsAgree" class="font-size-12 mb-0">문자수신</label>
                    <div class="position-relative">
                      <select
                        ref="modalMemberDataSmsAgree"
                        name="modalMemberDataSmsAgree"
                        id="modalMemberDataSmsAgree"
                        v-model="memberData.rejectSMS"
                        type="select"
                        class="form-control form-control-sm"
                        required
                      >
                        <option value="">(선택)</option>
                        <option value="1">문자수신 거부</option>
                        <option value="0">정상</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataEmailAgree" class="font-size-12 mb-0">이메일수신</label>
                    <div class="position-relative">
                      <select
                        ref="modalMemberDataEmailAgree"
                        name="modalMemberDataEmailAgree"
                        id="modalMemberDataEmailAgree"
                        v-model="memberData.rejectEmail"
                        type="select"
                        class="form-control form-control-sm"
                        required
                      >
                        <option value="">(선택)</option>
                        <option value="1">이메일수신 거부</option>
                        <option value="0">정상</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataEmail" class="font-size-12 mb-0">이메일</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.email" class="form-control form-control-sm pl-3" name="modalMemberDataEmail" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6 mb-1">
                  <div class="">
                    <label for="modalMemberDataInsertTime" class="font-size-12 mb-0">가입일자</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.insertTime" class="form-control form-control-sm bg-soft-secondary font-size-12 pl-3" placeholder="" name="modalMemberDataInsertTime" readonly />
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6 mb-1">
                  <div class="text-right">
                    <label for="modalMemberDataDelete" class="font-size-12 mb-0">회원삭제</label>
                    <div class="position-relative">
                      <button ref="modalMemberDataDelete" name="modalMemberDataDelete" id="modalMemberDataDelete" @click="deleteGiveMember()" class="btn btn-sm btn-danger font-weight-bold font-size-12">
                        <i class="mdi mdi-delete"></i> 삭제
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <div v-if="memberData.signatureImage" class="position-relative">
                      <img ref="modalMemberDataSignatureImage" name="modalMemberDataSignatureImage" id="modalMemberDataSignatureImage" @click="openSignatureWindow()" :src="returnSignatureImage(memberData.signatureImage)" class="img-fluid cursor-pointer border hp-100px" />
                    </div>
                    <div v-else class="position-relative">
                      <label for="modalMemberDataSignatureImage" class="font-size-12 mb-0">서명없음</label>
                      <button ref="modalMemberDataSignatureImage" name="modalMemberDataSignatureImage" id="modalMemberDataSignatureImage" disabled class="btn btn-sm btn-block btn-secondary font-size-12">
                        <i class="mdi mdi-image-filter-vintage"></i> 서명이 존재하지 않습니다.</br> (홈페이지 리뉴얼 이후 회원가입만 서명파일이 있습니다.)
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12 col-sm-12 mb-1">
                  <div v-if="checkMemberData() == true" class="">
                    <label for="modalMemberDataConvertToJpg" class="font-size-12 mb-0">이미지 변환</label>
                    <div class="position-relative">
                      <button ref="modalMemberDataConvertToJpg" name="modalMemberDataConvertToJpg" id="modalMemberDataConvertToJpg" @click="convertToJpg()" class="btn btn-sm btn-block btn-success font-weight-bold font-size-12">
                        <i class="mdi mdi-image-filter-vintage"></i> 후원신청서를 JPG로 변환
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <label for="modalMemberDataConvertCannot" class="font-size-12 mb-0">이미지 변환 불가</label>
                    <div class="position-relative">
                      <button ref="modalMemberDataConvertCannot" name="modalMemberDataConvertCannot" id="modalMemberDataConvertCannot" disabled class="btn btn-sm btn-block btn-secondary font-size-12">
                        <i class="mdi mdi-image-filter-vintage"></i> 후원신청서를 JPG로 변환 할 수 없습니다.</br> (아래 내용들 중 하나라도 입력되어 있으면 변환 가능합니다.)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-md-12 col-sm-12 p-2 border mt-4">
              <div class="row">
                <div v-if="checkMemberData() == true" class="col-xl-12 col-md-12 col-sm-12 mb-2">
                  <button @click="somethingDelete()" class="btn btn-sm btn-block btn-warning font-weight-bold font-size-12">
                    <span class="">↓↓</span>
                    <span class=""> 아래 내용들 모두 지우기 </span>
                    <span class="">↓↓</span>
                  </button>
                  <div class="col-xl-12 col-md-12 col-sm-12 text-center mb-2">
                    <span class="font-size-10 bg-soft-secondary text-danger font-weight-bold p-1 rounded d-inline-block font-size-11">
                      CMS프로그램에 아래 내용들 입력 후 일관성을 위해 지워주세요.
                    </span>
                  </div>
                </div>
                <div v-else class=""></div>
                <div class="col-xl-7 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataAddress" class="font-size-12 mb-0">주소</label>
                    <div class="position-relative">
                      <input type="text" 
                        v-model="memberData.address" 
                        class="form-control form-control-sm pl-3" 
                        placeholder="" 
                        name="modalMemberDataAddress" 
                      />
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataAddress2" class="font-size-12 mb-0">상세주소</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.address2" class="form-control form-control-sm pl-3" placeholder="" name="modalMemberDataAddress2" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataBank" class="font-size-12 mb-0">은행선택</label>
                    <div class="position-relative">
                      <div style="flex: 1; width: 100%;">
                        <select
                          ref="modalMemberDataBank"
                          name="modalMemberDataBank"
                          id="modalMemberDataBank"
                          v-model="memberData.bank"
                          type="select"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="">(선택)</option>
                          <option value="IM뱅크">IM뱅크 (구) 대구은행</option>
                          <option value="카카오뱅크">카카오뱅크</option>
                          <option value="국민은행">국민은행</option>
                          <option value="기업은행">기업은행</option>
                          <option value="신한은행">신한은행</option>
                          <option value="산업은행">산업은행</option>
                          <option value="농협은행">농협은행</option>
                          <option value="우리은행">우리은행</option>
                          <option value="하나은행">하나은행</option>
                          <option value="경남은행">경남은행</option>
                          <option value="부산은행">부산은행</option>
                          <option value="광주은행">광주은행</option>
                          <option value="저축은행">저축은행</option>
                          <option value="수협">수협</option>
                          <option value="우체국">우체국</option>
                          <option value="제주은행">제주은행</option>
                          <option value="토스뱅크">토스뱅크</option>
                          <option value="한국씨티은행">한국씨티은행</option>
                          <option value="SC제일은행">SC제일은행</option>
                          <option value="새마을금고">새마을금고</option>
                          <option value="신협중앙회">신협중앙회</option>
                          <option value="전북은행">전북은행</option>
                          <option value="케이뱅크">케이뱅크</option>
                          <option value="기타 (계좌번호 입력란에 은행명을 함께 입력해주세요)">기타(계좌번호와 함께 입력해주세요)</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">  
                    <label for="modalMemberDataAccountHolder" class="font-size-12 mb-0">예금주</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.accountHolder" class="form-control form-control-sm pl-3" placeholder="" name="modalMemberDataAccountHolder" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataAccountNumber" class="font-size-12 mb-0">계좌번호</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.accountNumber" class="form-control form-control-sm pl-3" placeholder="" name="modalMemberDataAccountNumber" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataCustomAmount" class="font-size-12 mb-0">월후원금액</label>
                    <div class="position-relative">
                      <input type="number" v-model="memberData.customAmount" class="form-control form-control-sm pl-3" name="modalMemberDataCustomAmount" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataSelectDay" class="font-size-12 mb-0">자동이체 출금일</label>
                    <div class="position-relative">
                      <div style="flex: 1; width: 100%;">
                        <select
                          ref="modalMemberDataSelectDay"
                          name="modalMemberDataSelectDay"
                          id="modalMemberDataSelectDay"
                          v-model="memberData.selectDay"
                          type="select"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="">(선택)</option>
                          <option value="5">매월 5일</option>
                          <option value="15">매월 15일</option>
                          <option value="25">매월 25일</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataReceiptAgree" class="font-size-12 mb-0">기부금영수증</label>
                    <div class="position-relative">
                      <div style="flex: 1; width: 100%;">
                        <select
                          ref="modalMemberDataReceiptAgree"
                          name="modalMemberDataReceiptAgree"
                          id="modalMemberDataReceiptAgree"
                          v-model="memberData.receiptAgree"
                          type="select"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="">(선택)</option>
                          <option value="발급함">발급함</option>
                          <option value="발급안함">발급안함</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataReferral" class="font-size-12 mb-0">추천인</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.referral" class="form-control form-control-sm pl-3" name="modalMemberDataReferral" maxlength="13" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataSsn" class="font-size-12 mb-0">주민등록번호</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.ssn" @input="formatSSN($event)" class="form-control form-control-sm pl-3" name="modalMemberDataSsn" maxlength="14" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataBirthday" class="font-size-12 mb-0">생년월일</label>
                    <div class="position-relative">
                      <input type="text" v-model="memberData.birthday" class="form-control form-control-sm pl-3" name="modalMemberDataBirthday" maxlength="13" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 mb-1">
                  <div class="">
                    <label for="modalMemberDataJoinReason" class="font-size-12 mb-0">가입동기</label>
                    <div style="flex: 1; width: 100%;">
                      <textarea
                        ref="modalMemberDataJoinReason"
                        v-model="memberData.joinReason"
                        name="modalMemberDataJoinReason"
                        id="modalMemberDataJoinReason"
                        class="form-control form-control-sm pl-3"
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 본문폼 종료 -->
          </div>
        </div>
      </div>

      <!-- 로그 보이기 버튼 -->
      <div class="col-xl-12 mt-2 mb-2">
        <div class="row">
          <div class="col-xl-12 col-md-8 col-sm-10 mb-2">
            <b-button @click="showMemberLogList()" class="btn btn-sm btn-square btn-block btn-info font-weight-bold font-size-12">
              <i class="mdi mdi-history"></i>
              변경 내역 {{ memberLogList.length }}건
            </b-button>
          </div>
        </div>
      </div>

      <!-- 로그 리스트 -->
      <div v-if="showMemberLogListOn" class="col-xl-12 col-md-12 col-sm-12 p-2 mt-4">
        <div v-if="memberLogList.length > 0" class="row">
          <div class="col-xl-12 col-md-12 col-sm-12">
            <table class="table table-sm font-size-11">
              <thead>
                <tr>
                  <th class="col-3 text-center">로그일자</th>
                  <th class="col-3 text-center">작성자</th>
                  <th class="col-6 text-center">내용</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in memberLogList" :key="log.idx">
                  <td class="text-center">{{ log.thisTime }}</td>
                  <td class="text-center">{{ log.adminNick }} ({{ log.adminIdx }})</td>
                  <td>
                    <!-- log.changeData : {상태: {before: 1, after: "3"}} 이런식임 이걸 찾아서 보여주자 -->
                    <div v-for="(change, key) in log.changeData" :key="key">
                      <div class="font-size-11">
                        {{ key }}: <span class="text-danger">{{ change.before }}</span> -> <span class="text-primary">{{ change.after }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- 로그 리스트 종료 -->
            
    </div>
  </template>
  